import {
  GetCity,
  GetCountry,
  GetState,
  Request_Sample_FormDetails,
} from "@/api/Api";
import { Grid, InputLabel, MenuItem, Select } from "@mui/material";
import TextField from "@mui/material/TextField";
import { useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import PhoneInput from "react-phone-input-2";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import DatePicker from "../DatePicker/DatePicker";
import Form from "../Form/Form";
import CustomInput from "../Input/input";
import TermsConditionBtn from "../TermsConditionBtn";
import dayjs from "dayjs";
import { sendEventToGTM } from "@/utils/Common";
import {
  trackFormLoaded,
  trackFormSubmitted,
  FORM_TYPES,
  getPageType,
} from "@/utils/gtmEvents";
import { usePathname } from "next/navigation";

const time = {
  "00:00": "12:00 AM",
  "01:00": "1:00 AM",
  "02:00": "2:00 AM",
  "03:00": "3:00 AM",
  "04:00": "4:00 AM",
  "05:00": "5:00 AM",
  "06:00": "6:00 AM",
  "07:00": "7:00 AM",
  "08:00": "8:00 AM",
  "09:00": "9:00 AM",
  "10:00": "10:00 AM",
  "11:00": "11:00 AM",
  "12:00": "12:00 PM",
  "13:00": "1:00 PM",
  "14:00": "2:00 PM",
  "15:00": "3:00 PM",
  "16:00": "4:00 PM",
  "17:00": "5:00 PM",
  "18:00": "6:00 PM",
  "19:00": "7:00 PM",
  "20:00": "8:00 PM",
  "21:00": "9:00 PM",
  "22:00": "10:00 PM",
  "23:00": "11:00 PM",
};

const RequestSample = ({
  Options = [],
  chemicalName,
  id,
  request_type,
  handleClose,
}) => {
  const [countryName, setCountry] = useState([]);
  const [state, setState] = useState([]);

  const [city, setCity] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selected, setSelected] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const pathname = usePathname();
  const currentDate = new Date();
  const currentHour = currentDate.getHours();
  const getTime = (call_date) => {
    const dateObject = new Date();
    let date = dateObject.getDate();
    let selectedDate = dayjs(call_date).date();
    if (selectedDate === date) {
      return Object.entries(time).filter(([timeValue]) => {
        const [hours] = timeValue.split(":");
        return parseInt(hours, 10) > currentHour;
      });
    }

    return Object.entries(time);
  };
  const handleContactForm = async (values, resetForm) => {
    setIsLoading(true);
    try {
      const res = await Request_Sample_FormDetails({
        ...values,
        NameofProduct: id || values?.NameofProduct,
        recaptcha: values.recaptcha,
        request_type,
      });

      if (res?.data?.status === 200) {
        // Track FORM_SUBMITTED event
        const pageUrl = typeof window !== "undefined" ? window.location.href : "";
        const pageType = getPageType(pathname);
        trackFormSubmitted(FORM_TYPES.REQUEST_SAMPLE_QUOTES, pageUrl, pageType);

        toast.success(
          "We have received your request, someone from our team will connect with you shortly."
        );
        setIsChecked(false);
        window?.grecaptcha?.reset();
        resetForm("");
        handleClose();
      }
    } catch (error) {
      toast.info("Something went wrong, please try again!");
    }
    setIsLoading(false);
  };

  const onCity = (e) => {
    setSelectedCity(e.target.value);
  };
  const checkedPolicy = () => {
    setIsChecked(!isChecked);
  };

  const getCountries = async () => {
    try {
      const countryData = await GetCountry();
      setCountry(countryData);
    } catch (error) {
      toast.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getCountries();

    // Track FORM_LOADED event
    const pageUrl = typeof window !== "undefined" ? window.location.href : "";
    const pageType = getPageType(pathname);
    trackFormLoaded(FORM_TYPES.REQUEST_SAMPLE_QUOTES, pageUrl, pageType);
  }, [pathname]);
  const getState = async () => {
    try {
      const stateData = await GetState(selectedCountry);
      setState(stateData);
    } catch (error) {
      toast.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    if (selectedCountry !== "") {
      getState();
    }
  }, [selectedCountry]);
  const getCity = async () => {
    try {
      const city = await GetCity(selected, selectedCountry);
      setCity(city);
    } catch (error) {
      toast.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    if (selected !== "" && selectedCountry !== "") {
      getCity();
    }
  }, [selected, selectedCountry]);
  //  useEffect(() => {
  //    const fetchData = async () => {
  //      try {
  //        const countryData = await GetCountry();
  //        setCountry(countryData);
  //        if (selectedCountry) {
  //          const stateData = await GetState(selectedCountry);
  //          setState(stateData);

  //          if (selected && selectedCountry) {
  //            const city = await GetCity(selected, selectedCountry);
  //            setCity(city);
  //          }
  //        }
  //      } catch (error) {
  //        console.error("Error fetching data:", error);
  //      }
  //    };

  //    fetchData();
  //  }, [selectedCountry, selected]);

  return (
    <>
      <div>
        <Form
          handleSubmit={handleContactForm}
          initialValues={{
            FirstName: "",
            LastName: "",
            EmailId: "",
            MobilewithCountryCode: "",
            CompanyName: "",
            address1: "",
            address2: "",
            country: selectedCountry,
            city: selectedCity,
            state: selected,
            postalCode: "",
            call_date: null,
            time: "",
            info: "",
            recaptcha: null,
            NameofProduct: chemicalName || "",
          }}
          enableReinitialize={true}
          validationSchema={schema}
        >
          {(formik) => {
            const {
              values,
              errors,
              handleChange,
              setFieldValue,
              handleBlur,
              touched,
            } = formik;
            return (
              <>
                <Grid
                  container
                  rowSpacing={3}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item xs={12} sm={12} lg={6}>
                    <CustomInput
                      required
                      label="First Name"
                      name="FirstName"
                      onBlur={handleBlur}
                      value={values?.FirstName}
                      handleChange={handleChange}
                      error={errors.FirstName}
                      touched={touched.FirstName}
                      helperText={
                        errors.FirstName && touched.FirstName
                          ? errors.FirstName
                          : ""
                      }
                      placeholder="First Name"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6}>
                    <CustomInput
                      required
                      label="Last Name"
                      name="LastName"
                      onBlur={handleBlur}
                      value={values?.LastName}
                      handleChange={handleChange}
                      error={errors.LastName}
                      touched={touched.LastName}
                      helperText={
                        errors.LastName && touched.LastName
                          ? errors.LastName
                          : ""
                      }
                      placeholder="Last Name"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6}>
                    <CustomInput
                      required
                      label="Email ID "
                      name="EmailId"
                      onBlur={handleBlur}
                      value={values?.EmailId}
                      handleChange={handleChange}
                      error={errors.EmailId}
                      touched={touched.EmailId}
                      helperText={
                        errors.EmailId && touched.EmailId ? errors.EmailId : ""
                      }
                      placeholder="Email ID"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6} mt={"-0.1rem"}>
                    <InputLabel
                      htmlFor="MobilewithCountryCode"
                      sx={{
                        color: "#161616",
                        fontSize: "15px",
                        lineHeight: "21px",
                      }}
                    >
                      Phone no
                    </InputLabel>
                    <div className="mt-[0.58rem]">
                      <PhoneInput
                        country={"us"}
                        enableSearch={true}
                        name="MobilewithCountryCode"
                        value={values?.MobilewithCountryCode}
                        onChange={(value) => {
                          setFieldValue("MobilewithCountryCode", value);
                        }}
                        onBlur={handleBlur}
                        sx={{
                          height: "50px",
                          width: "100%",

                          paddingTop: "10px", // Set width explicitly to 100%
                        }}
                        error={
                          errors.MobilewithCountryCode &&
                          touched.MobilewithCountryCode
                        }
                      />
                      {errors.MobilewithCountryCode &&
                      touched.MobilewithCountryCode ? (
                        <p
                          className="text-[#d32f2f]"
                          style={{
                            fontSize: "20px",
                          }}
                        >
                          {"Phone no is required"}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </Grid>

                  <Grid item xs={12} lg={6} md={12} sm={12}>
                    <CustomInput
                      label="Company/Organization "
                      name="CompanyName"
                      onBlur={handleBlur}
                      value={values?.CompanyName}
                      handleChange={handleChange}
                      error={errors.CompanyName}
                      touched={touched.CompanyName}
                      helperText={
                        errors.CompanyName && touched.CompanyName
                          ? errors.CompanyName
                          : ""
                      }
                      placeholder="Company/Organization"
                    />
                  </Grid>
                </Grid>

                <Grid
                  container
                  rowSpacing={3}
                  columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                >
                  <Grid item sm={12} md={12} lg={12} mt={"2rem"}>
                    <table className="w-full">
                      <tr>
                        <td className="w-[10%] font-medium text-[16px]">
                          Address
                        </td>
                        <td className="w-[90%]">
                          <hr></hr>
                        </td>
                      </tr>
                    </table>
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6}>
                    <CustomInput
                      label="Address"
                      name="address1"
                      onBlur={handleBlur}
                      value={values?.address1}
                      handleChange={handleChange}
                      error={errors.address1}
                      touched={touched.address1}
                      helperText={
                        errors.address1 && touched.address1
                          ? errors.address1
                          : ""
                      }
                      placeholder="Address line 1"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} lg={6} mt={"1.56rem"}>
                    <CustomInput
                      name="address2"
                      onBlur={handleBlur}
                      value={values?.address2}
                      handleChange={handleChange}
                      error={errors.address2}
                      touched={touched.address2}
                      helperText={
                        errors.address2 && touched.address2
                          ? errors.address2
                          : ""
                      }
                      placeholder="Address line 2"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <InputLabel
                      htmlFor="country"
                      className="w-[30%] mt-2 "
                      sx={{
                        color: "#161616",
                        fontSize: "15px",
                        marginBottom: "5px",
                      }}
                    >
                      Country
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: "200px",
                            // maxWidth: "200px",
                          },
                        },
                      }}
                      slotProps={{
                        popup: {
                          disablePortal: true,
                        },
                      }}
                      displayEmpty
                      renderValue={
                        values?.country
                          ? undefined
                          : () => (
                              <span
                                style={{
                                  color: "#8080805e",
                                  fontStyle: "normal",
                                }}
                              >
                                {" "}
                                Select Country
                              </span>
                            )
                      }
                      value={values?.country}
                      onChange={(e) => {
                        setSelectedCountry(e.target.value);
                        setFieldValue("country", e.target.value);
                      }}
                      onBlur={handleBlur}
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        width: "100%",
                        borderRadius: "10px",
                        boxShadow: "none",
                        ".MuiSelect-select": {
                          color: "black",
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #B3B3B3",
                        },
                        "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                          {
                            border: "1px solid #161616",
                          },
                        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          {
                            border: "1px solid #161616",
                          },
                      }}
                      name="country"
                      error={errors.country && touched.country}
                      helperText={
                        errors.country && touched.country ? errors.country : ""
                      }
                    >
                      <MenuItem value={""}>
                        <em style={{ color: "#8080805e", fontStyle: "normal" }}>
                          Select Country
                        </em>
                      </MenuItem>
                      {countryName.map((item) => (
                        <MenuItem key={item.id} value={item?.iso2}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>

                    {errors.country && touched.country ? (
                      <p className="text-[red]">{errors.country}</p>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <InputLabel
                      htmlFor="state"
                      className="w-[30%] mt-2  "
                      sx={{
                        color: "#161616",
                        fontSize: "15px",
                        marginBottom: "5px",
                      }}
                    >
                      State
                    </InputLabel>
                    <Select
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: "200px",
                          },
                        },
                      }}
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={values?.state}
                      onChange={(e) => {
                        setSelected(e.target.value);
                        setFieldValue("state", e.target.value);
                      }}
                      onBlur={handleBlur}
                      inputProps={{ "aria-label": "Without label" }}
                      displayEmpty
                      renderValue={
                        values?.state
                          ? undefined
                          : () => (
                              <span
                                style={{
                                  color: "#8080805e",
                                  fontStyle: "normal",
                                }}
                              >
                                {" "}
                                Select State
                              </span>
                            )
                      }
                      sx={{
                        width: "100%",

                        ".MuiSelect-select": {
                          color: "black",
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #B3B3B3",
                        },
                        "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                          {
                            border: "1px solid #B3B3B3",
                          },
                        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          {
                            border: "1px solid #B3B3B3",
                          },
                      }}
                      name="state"
                      error={errors.state && touched.state}
                      helperText={
                        errors.state && touched.state ? errors.state : ""
                      }
                    >
                      <MenuItem disabled value={"none"}>
                        <em style={{ color: "#8080805e", fontStyle: "normal" }}>
                          Select States
                        </em>
                      </MenuItem>

                      {state.map((item) => (
                        <MenuItem key={item.id} value={item?.iso2}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.state && touched.state ? (
                      <p className="text-[red]">{errors.state}</p>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12} md={4} lg={4}>
                    <InputLabel
                      htmlFor="name"
                      className="w-[30%] mt-2 font-normal "
                      sx={{
                        fontSize: "15px",
                        color: "#161616",
                        marginBottom: "5px",
                      }}
                    >
                      City
                    </InputLabel>
                    <Select
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: "200px",
                          },
                        },
                      }}
                      displayEmpty
                      renderValue={
                        values?.city
                          ? undefined
                          : () => (
                              <span
                                style={{
                                  color: "#8080805e",
                                  fontStyle: "normal",
                                }}
                              >
                                {" "}
                                Select City
                              </span>
                            )
                      }
                      labelId="demo-simple-select-helper-label"
                      id="demo-simple-select-helper"
                      value={values?.city}
                      onChange={(e) => {
                        setSelectedCity(e.target.value);
                        setFieldValue("city", e.target.value);
                      }}
                      onBlur={handleBlur}
                      inputProps={{ "aria-label": "Without label" }}
                      sx={{
                        width: "100%",
                        ".MuiSelect-select": {
                          color: "black",
                        },
                        ".MuiOutlinedInput-notchedOutline": {
                          border: "1px solid #B3B3B3",
                        },
                        "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                          {
                            border: "1px solid #B3B3B3",
                          },
                        "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                          {
                            border: "1px solid #B3B3B3",
                          },
                      }}
                      name="city"
                      placeholder="city"
                      error={errors.city && touched.city}
                      helperText={
                        errors.city && touched.city ? errors.city : ""
                      }
                    >
                      <MenuItem value={""}>
                        <em style={{ color: "#8080805e", fontStyle: "normal" }}>
                          Select City
                        </em>
                      </MenuItem>

                      {city.map((e) => {
                        return (
                          <MenuItem key={e} value={e?.name}>
                            {e?.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                    {errors.city && touched.city ? (
                      <p className="text-[red]">{errors.city}</p>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={4} mt={"0.3rem"}>
                    <CustomInput
                      label="Postal Code"
                      name="postalCode"
                      onBlur={handleBlur}
                      value={values?.postalCode}
                      handleChange={handleChange}
                      error={errors.postalCode}
                      touched={touched.postalCode}
                      helperText={
                        errors.postalCode && touched.postalCode
                          ? errors.postalCode
                          : ""
                      }
                      placeholder="Postal Code"
                    />
                  </Grid>
                  <Grid item sm={12} md={12} lg={12}>
                    <table className="w-full">
                      <tr>
                        <td className="w-[15%] font-medium text-[16px]">
                          Requirement
                        </td>
                        <td className="w-[85%]">
                          <hr></hr>
                        </td>
                      </tr>
                    </table>
                  </Grid>
                  {Options.map((items) => (
                    <>
                      <Grid item xs={12} sm={12} md={6} lg={items?.width}>
                        {items?.label === "Name of Product" ? (
                          <CustomInput
                            label={items?.label}
                            disablePast={
                              items.label === "Tentative requisition date"
                            }
                            name={items?.value}
                            onBlur={handleBlur}
                            value={values[items?.value] || ""}
                            handleChange={handleChange}
                            error={errors[items?.value]}
                            touched={touched[items?.value]}
                            helperText={
                              errors[items?.value] && touched[items?.value]
                                ? errors[items?.value]
                                : ""
                            }
                            country={countryName}
                            placeholder={items?.label}
                          />
                        ) : (
                          <CustomInput
                            label={items?.label}
                            disablePast={
                              items.label === "Tentative requisition date"
                            }
                            {...(items.label === "Tentative requisition date"
                              ? {
                                  slotProps: {
                                    textField: {
                                      helperText: errors.Tentativerequistiondate
                                        ? errors.Tentativerequistiondate
                                        : "",
                                    },
                                  },
                                }
                              : {})}
                            name={items?.value}
                            onBlur={handleBlur}
                            value={values[items?.value] || ""}
                            handleChange={handleChange}
                            error={errors[items?.value]}
                            touched={touched[items?.value]}
                            helperText={
                              errors[items?.value] && touched[items?.value]
                                ? errors[items?.value]
                                : ""
                            }
                            country={countryName}
                            placeholder={items?.label}
                          />
                        )}
                      </Grid>
                    </>
                  ))}
                  <Grid
                    container
                    item
                    xs={12}
                    columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                  >
                    <Grid item xs={12}>
                      <InputLabel
                        htmlFor="name"
                        sx={{
                          color: "#161616",
                          marginBottom: "8px",
                          fontWeight: 400, // Font weight 400 is normal
                          fontSize: "15px",
                          lineHeight: "21px",
                        }}
                      >
                        Preferred date and time for a call back
                      </InputLabel>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <DatePicker
                        disablePast={"true"}
                        className="lowercase rounded-[20px]"
                        onChange={(value) => setFieldValue("call_date", value)}
                        value={values?.call_date || null}
                        slotProps={{
                          textField: {
                            helperText: errors.call_date
                              ? errors.call_date
                              : "",
                          },
                        }}
                        name="call_date"
                        sx={{
                          ".MuiInputLabel-root.MuiInputLabel-formControl": {
                            color: "#8080805",
                          },
                          "& .MuiInputBase-input": {
                            fontStyle: "lowercase", // Add this line to set the font size
                            color: "0000009e",
                          },
                        }}
                        showTimeInput={false}
                        error={errors.call_date && touched.call_date}
                        helperText={
                          errors.call_date && touched.call_date
                            ? errors.call_date
                            : ""
                        }
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <div className=" md:mt-0 sm:mt-4 xs:mt-4 contact-us-select ">
                        <Select
                          labelId="demo-simple-select-helper-label"
                          id="demo-simple-select-helper"
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: "200px",
                              },
                            },
                          }}
                          displayEmpty
                          renderValue={
                            values?.time
                              ? undefined
                              : () => (
                                  <span
                                    style={{
                                      color: "#8080805e",
                                      fontStyle: "normal",
                                    }}
                                  >
                                    {" "}
                                    Select Time
                                  </span>
                                )
                          }
                          value={values?.time}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          inputProps={{ "aria-label": "Without label" }}
                          sx={{
                            width: "100%",
                            boxShadow: "none",
                            ".MuiSelect-select": {
                              color: "black",
                            },
                            ".MuiOutlinedInput-notchedOutline": {
                              border: "1px solid #B3B3B3",
                            },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: "1px solid #161616",
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: "1px solid #161616",
                              },
                          }}
                          name="time"
                          error={errors.time && touched.time}
                          helperText={
                            errors.time && touched.time ? errors.time : ""
                          }
                        >
                          <MenuItem value={""}>
                            <em
                              style={{
                                color: "#8080805e",
                                fontStyle: "normal",
                              }}
                            >
                              {" "}
                              Select Time
                            </em>
                          </MenuItem>
                          {values?.call_date &&
                            getTime(values?.call_date).map(
                              ([timeValue, label]) => (
                                <MenuItem key={timeValue} value={timeValue}>
                                  {label}
                                </MenuItem>
                              )
                            )}
                        </Select>
                      </div>
                    </Grid>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <InputLabel
                      htmlFor="Informations"
                      sx={{
                        color: "#161616",
                        marginBottom: "8px",

                        fontWeight: 400, // Font weight 400 is normal
                        fontSize: "15px",
                        lineHeight: "21px",
                      }}
                    >
                      Additional information that will help us connect better{" "}
                      {/* <span className="text-[red]">*</span> */}
                    </InputLabel>
                    <TextField
                      placeholder="Type here..."
                      name="info"
                      onBlur={handleBlur}
                      multiline
                      rows={3}
                      sx={{
                        width: "100%",
                        "& .MuiOutlinedInput-root": {
                          "&.Mui-focused fieldset": {
                            borderColor: "#B3B3B3",
                          },
                        },
                      }}
                      value={values?.info}
                      onChange={handleChange}
                      error={errors.info && touched.info}
                      helperText={
                        errors.info && touched.info ? errors.info : ""
                      }
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sx={{
                      paddingTop: "1rem !important",
                    }}
                  >
                    <TermsConditionBtn
                      checkedPolicy={checkedPolicy}
                      isChecked={isChecked}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    md={12}
                    lg={12}
                    sx={{
                      paddingTop: "1rem !important",
                    }}
                  >
                    <ReCAPTCHA
                      style={{
                        transform: " scale(0.8)",
                        transformOrigin: "0 0",
                      }}
                      name="recaptcha"
                      isChecked={isChecked}
                      sitekey={process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY}
                      onChange={(value) => {
                        setFieldValue("recaptcha", value);
                      }}
                      size="normal"
                    />
                    {errors.recaptcha && touched.recaptcha ? (
                      <p
                        style={{
                          fontSize: "12px",
                          marginTop: "-0.8rem",
                        }}
                        className="text-[#d32f2f]"
                      >
                        {errors.recaptcha}
                      </p>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    // sx={{
                    //   marginTop: "-2rem",
                    // }}
                  >
                    <button
                      className={`w-[163px] text-[#FFFFFF] cursor-pointer h-[48px] rounded-[4px] disabled:bg-[grey] font-semibold text-[16px] bg-red`}
                      type="submit"
                      disabled={
                        !values?.EmailId ||
                        !values?.FirstName ||
                        !values?.LastName ||
                        !values?.recaptcha ||
                        !isChecked ||
                        isLoading
                      }
                    >
                      {isLoading ? "Submitting..." : "Submit"}
                    </button>
                  </Grid>
                </Grid>
              </>
            );
          }}
        </Form>
      </div>
    </>
  );
};

export default RequestSample;
const today = new Date();
today.setHours(0, 0, 0, 0);
const schema = Yup.object().shape({
  FirstName: Yup.string()
    .trim()
    .matches(
      /^[A-Za-z]+$/,
      "First Name must contain only alphabetic characters"
    )
    .required("First Name is required"),
  LastName: Yup.string()
    .trim()
    .matches(/^[A-Za-z]+$/, "Last Name must contain only alphabetic characters")
    .required("Last Name is required"),
  EmailId: Yup.string()
    .matches(
      /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
      "Enter a valid email address"
    )
    .required("Email is required"),
  recaptcha: Yup.string().required("Captcha must be checked"),
  Tentativerequistiondate: Yup.date()
    .typeError("Invalid Date")
    .nullable(true)
    .min(today, "Date cannot be in the past"),
  call_date: Yup.date()
    .typeError("Invalid Date")
    .nullable(true)
    .min(today, "Date cannot be in the past"),
  info: Yup.string().max(500, "Information exceeds 500 characters"),
  Detailsofsampleneeded: Yup.string().max(
    100,
    "Details exceeds 100 characters"
  ),
});
